import { ReactNode } from 'react';

import { Container, ThemeProvider } from '@mui/material';
import { theme } from 'config/defaultTheme';
import { AdminFooter } from 'features/admin/components/AdminFooter/AdminFooter';
import { AdminHeader } from 'features/admin/components/AdminHeader/AdminHeader';
import { useSelector } from 'react-redux';
import { useAppSelector } from 'store/hooks';
import { selectFeatureFlags } from 'store/store';
import { selectUserState } from 'store/user/UserSlice';

export interface LpiLayoutTemplateProps {
  children: ReactNode;
}

export default function LpiLayoutTemplate({ children }: LpiLayoutTemplateProps) {
  const user = useSelector(selectUserState).user;
  const { flags } = useAppSelector(selectFeatureFlags);
  const isBatchReportsEnabled = flags?.['enable-batch-reports'] || false;

  return (
    <ThemeProvider theme={theme}>
      { user && (<AdminHeader
        user={
          {
            firstName: user?.firstName || '',
            lastName: user?.lastName || '',
            email: user?.email || '',
          }
        }
        isBatchReportsEnabled={isBatchReportsEnabled}
      /> )}

      <Container maxWidth={false} sx={{ minHeight: '100vh' }}>
        {children}
      </Container>

      <AdminFooter />
    </ThemeProvider>
  );
}
